import React from 'react';

import { Heading3, spacing } from '../../../../../theme';
import { ItemContainer } from '../style';
import { styled } from 'styled-components';
import { NameValuePair } from '../../models';

type Props = { 
    key: number | string; 
    orderGroupItems: NameValuePair[];
};
const StyledHeading = styled(Heading3)`
    display: flex;
    align-items: center;
    gap: ${spacing.spacing2};
`;
const renderOrderGroupItem = (items: NameValuePair[]) => {
    const html = [];
    items.forEach(({name, value}) => {
        html.push(
            <>
                <StyledHeading styledAs="h5">
                    {name}
                </StyledHeading>
                <div>
                    <StyledHeading styledAs="h5">
                        {value}
                    </StyledHeading>
                </div>
            </>);
    });
    return html;
};

export default function OrderGroupItem({ key, orderGroupItems }: Props) {
    return (
        <ItemContainer>
            {orderGroupItems?.length && renderOrderGroupItem(orderGroupItems)}
        </ItemContainer>
    )
}
